import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import withRouter from '../hooks/withRouter'
import { Home } from '../pages/home'
import { Blog } from '../pages/blog'
import { BlogPost } from '../pages/blog/BlogPost'
import { BlogCategory } from '../pages/blog/BlogCategory'
import { Projects } from '../pages/projects'
import { Travel } from '../pages/travel'
import { ProjectViewer } from '../pages/projects/ProjectViewer'
import { Socialicons } from '../components/socialicons'

const AnimatedRoutes = withRouter(({ location }) => (
  <TransitionGroup className="page-transition-group">
    <CSSTransition
      key={location.pathname}
      classNames="page"
      timeout={300}
      unmountOnExit
    >
      <div className="page-wrapper">
        <Routes location={location}>
          <Route exact path='/' element={<Home />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog/life' element={<BlogCategory category="life" />} />
          <Route path='/blog/tech' element={<BlogCategory category="tech" />} />
          <Route path='/blog/:slug' element={<BlogPost />} />
          <Route path='/travel' element={<Travel />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/projects/:projectId' element={<ProjectViewer />} />
        </Routes>
      </div>
    </CSSTransition>
  </TransitionGroup>
))

function AppRoutes() {
  return (
    <div className='s_c'>
      <AnimatedRoutes />
      <Socialicons />
    </div>
  )
}

export default AppRoutes
